<template>
    <div class="wrap">
        <!-- <span @click="$router.push({name:'ProtectFile'})">返回</span> -->
        <div class="title">
            <h3>文件信息</h3>
            <span class="deleteBtn downBtn" @click="deleteFile" v-if="opusInfo.sourceFileUploadType !== 0">删除原件</span>
            <span class="downBtn" v-if="opusInfo.sourceFileUploadType == 0">
                <b>上传原件</b>
                <input type="file" class="uploadfile" @change="addfile(1)" ref="inputer1">
            </span>
            <span class="downBtn" @click="download" v-else>下载原件</span>
        </div>
        <div class="section">
            <div class="fileArea">
                <div class="marker">
                    <img 
                        class="noUp" 
                        src="@/assets/img/noUp.png" alt="" 
                        v-if="opusInfo.sourceFileUploadType == 0" 
                    />
                    <img 
                        class="noUp" 
                        src="@/assets/img/up.png" alt="" 
                        v-else-if="!suffix && !isVideo && !opusInfo.isExpired"
                    />
                </div>
                <!-- 储存已过期 -->
                <div class="preview_box" v-if="opusInfo.isExpired">
                    <div class="preview_wrap">
                        <div class="noLook">
                            <p class="expiredText">存储已过期</p>
                        </div>
                    </div>
                </div>
                <!-- 无原件，可上传 -->
                <div class="upload_box" v-else-if="opusInfo.sourceFileUploadType == 0">
                    <input
                        type="file"
                        class="uploadfile"
                        @change="addfile(2)"
                        ref="inputer2"
                    />
                    <div class="addIco">
                        <img src="@/assets/img/addIcon.png" alt="" />
                        <p>上传原件</p>
                    </div>
                </div>
                <!-- 可预览图片原件 -->
                <div class="preview_box" v-else-if="suffix">
                    <div class="preview_wrap">
                        <img class="pic" :src="opusInfo.sourceFileStorePathUrl" alt="" @click="imgPreview(opusInfo.sourceFileStorePathUrl)">
                    </div>
                </div>
                <!-- 可预览视频原件 -->
                <div class="preview_box" v-else-if="isVideo">
                    <div class="preview_wrap">
                        <video-player
                            class="video-player vjs-custom-skin pic"
                            ref="video"
                            :playsinline="true"
                            :options="playerOptions"
                        ></video-player>
                        <div class="playVideo" @click="playVideo"></div>
                    </div>
                </div>
                <!-- 不可预览原件格式 -->
                <div class="preview_box" v-else>
                    <div class="preview_wrap">
                        <div class="noLook">
                            <img src="@/assets/img/questionIcon.png" alt="" />
                            <p>暂不支持预览</p>
                        </div>
                    </div>
                </div>
            </div>
            <p class="expiredTime" v-if="opusInfo.isExpired">{{opusInfo.storeExpiredAt | formatYMD}}存储到期</p>
            <p class="expiredTime" v-else-if="opusInfo.sourceFileUploadType == 0"></p>
            <p class="expiredTime" v-else>存储到期日：{{opusInfo.storeExpiredAt | formatYMD}}</p>

            <div class="userinfo">
                <ul>
                    <li>
                        <p><b>申请人：</b>{{ opusInfo.applyName }}</p>
                    </li>
                    <li>
                        <p><b>申请账号：</b>{{opusInfo.applyAccount}}</p>
                    </li>
                    <li>
                        <p><b>文件类型：</b>{{ opusInfo.fileTypeName }}</p>
                    </li>
                    
                    <li>
                        <p><b>文件名称：</b>{{ opusInfo.opusName }}</p>
                    </li>
                    <li>
                        <p>
                            <b :class="opusInfo.modified?'remark':''">
                                备注：
                                <van-button icon="success" type="info" size="mini" v-if="opusInfo.modified" class="subBtn" @click="updateRemark" />
                            </b>
                            <span v-show="!opusInfo.modified">
                                <span style="color:#666">{{ opusInfo.applyRemark }}</span>
                                <van-icon name="edit" class="editBtn" @click="updateRemarkShow" v-if="!opusInfo.modified"/>
                            </span>
                            <span v-show="opusInfo.modified">
                                <van-field
                                    class="textarea"
                                    v-model="opusInfo.applyRemark"
                                    rows="2"
                                    autosize
                                    label=""
                                    type="textarea"
                                    placeholder="请输入备注"
                                    maxlength="100"
                                    show-word-limit
                                />
                            </span>
                        </p>
                    </li>
                    <li>
                        <p><b>申请时间：</b>{{ opusInfo.tsaAt?opusInfo.tsaAt:'' | formatDate}} (UTC+8)</p>
                    </li>
                    <li>
                        <p><b>申请人文件自述：</b>{{ opusInfo.opusDescribe }}</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="title">
            <h3>时间戳认证证书</h3>
            <span class="downBtn" @click="download('tsa')">下载证书</span>
        </div>
        <div class="section">
            <ul>
                <li>
                    <p>
                        <b>证书编号：</b>
                        {{ opusInfo.pdfTsaSerialNo }}
                        <van-icon
                            class-prefix="vant-ali-fuzhi"
                            class="copyicon copybtn"
                            :data-clipboard-text="opusInfo.pdfTsaSerialNo"
                            @click="copy"
                        />
                    </p>
                </li>
                <li>
                    <p>
                        <b>时间戳认证码：</b>
                        {{ opusInfo.fileHash }}
                        <van-icon
                            class-prefix="vant-ali-fuzhi"
                            class="copyicon copybtn"
                            :data-clipboard-text="opusInfo.fileHash"
                            @click="copy"
                        />
                    </p>
                </li>
                <li>
                    <p><b>时间戳签发时间：</b>{{ opusInfo.tsaAt?opusInfo.tsaAt:'' | formatDate}} (UTC+8)</p>
                </li>
            </ul>
            <div class="certificate">
                <img :src="opusInfo.pdfThumbnailUrl" @click="imgPreview(opusInfo.pdfThumbnailUrl)" alt="">
            </div>
        </div>
        <div class="btns">
            <span class="back" @click="$router.replace({path:'/file/ProtectFile'})">返回</span>
            <div class="updown">
                <span class="pre" @click="pre" v-if="index!=0">上一个</span>
                <span class="next" @click="next" v-if="!last">下一个</span>
            </div>
        </div>
        <!-- hash计算层 -->
        <div class="zhe" v-if="zhe">
            <div class="cprogress">
                <van-circle v-model="currentRate" :rate="percentage" :speed="percentage" :text="percentage+'%'" :stroke-width="60" />
            </div>
        </div>
        <!-- 文件上传进度条 -->
        <van-dialog v-model="diaProgress" :showConfirmButton="false" class="tem_dialog" :before-close="overUpload">
            <template #title>
                <div class="headerDialog">
                    <h3>正在上传文件，请耐心等待</h3>
                    <van-icon name="cross" class="close" @click="close" />
                </div>
            </template>
            <div class="diaProgress">
                <van-progress :percentage="percentage" color="#80C437" stroke-width="10"  />
            </div>
        </van-dialog>
        <!-- 视频预览层 -->
        <div class="mask" v-if="videoMask">
            <div class="video">
                <b class="close" @click="videoMask=false"><van-icon name="cross" /></b>
                <div class="video_body">
                    <video-player
                        class="video-player vjs-custom-skin"
                        ref="video"
                        :playsinline="true"
                        :options="playerOptions"
                    ></video-player>
                </div>
            </div>
        </div>
        
        <!-- 已过期且余额不足情况下，下载 -->
        <van-dialog 
            v-model="downNoEnoughDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            :confirmButtonText="userInfo.userType == 'ADMIN_ACCOUNT'?'立即充值':'我知道了'" 
            :show-cancel-button="userInfo.userType == 'ADMIN_ACCOUNT'"
            cancelButtonText="取消" 
            @confirm="goRecharge('down')"
        >
            <template #title>
                <van-icon name="warning" class="warning"/>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <h3 v-if="userInfo.userType == 'ADMIN_ACCOUNT'">该文件尚有未支付的存储费，需支付后方可下载</h3>
                    <h3 v-else>该文件尚有未支付的存储费，需支付后方可下载，请联系主账号充值</h3>
                    <p>存储已超期<b class="red">{{opusInfo.expiredDays}}</b>天，本次预计消耗时间戳<b class="blue">{{opusInfo.storeTsCount}}</b>个</p>
                </div>
            </div>
        </van-dialog>
        <!-- 身份子账号，文件已过期且主账号分配余额不足情况下，下载 -->
        <van-dialog 
            v-model="downNoEnoughChildDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            confirmButtonText="我知道了" 
            :show-cancel-button="false"
            @confirm="downNoEnoughChildDiaBox=false"
        >
            <template #title>
                <van-icon name="warning" class="warning"/>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <h3>该文件尚有未支付的存储费，您的时间戳已用完，请联系主账号再次分配</h3>
                    <p>存储已超期<b class="red">{{opusInfo.expiredDays}}</b>天，本次预计消耗时间戳<b class="blue">{{opusInfo.storeTsCount}}</b>个</p>
                </div>
            </div>
        </van-dialog>
        <!-- 已过期且余额足够情况下，下载 -->
        <van-dialog 
            v-model="downEnoughDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            confirmButtonText="继续下载" 
            show-cancel-button
            cancelButtonText="取消" 
            @confirm="handlDownload"
        >
            <template #title>
                <van-icon name="warning" class="warning"/>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <h3>该文件尚有未支付的存储费，需支付后方可下载</h3>
                    <p>存储已超期<b class="red">{{opusInfo.expiredDays}}</b>天，本次预计消耗时间戳<b class="blue">{{opusInfo.storeTsCount}}</b>个</p>
                </div>
            </div>
        </van-dialog>
        <!-- 删除提示框 -->
        <van-dialog 
            v-model="deleteDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            confirmButtonText="确定" 
            show-cancel-button
            cancelButtonText="取消" 
            @confirm="handleDelete"
        >
            <template #title>
                <van-icon name="warning" class="warning"/>
            </template>
            <div class="dialog_cnt">
                <div class="content">
                    <h3>删除后原件将无法随时查看和下载，再次上传将重新收取存储时间戳，确定删除么？</h3>
                </div>
            </div>
        </van-dialog>
        <!-- 上传提示框,余额够用 -->
        <van-dialog 
            v-model="balanceEnoughDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            confirmButtonText="继续上传" 
            show-cancel-button
            cancelButtonText="取消" 
            @confirm="handleUpload"
            @cancel="cancelUpload"
        >
            <div class="dialog_cnt">
                <div class="content">
                    <h3>本文件大小为<b class="blue">{{fileSize}}</b>，存储需消耗可信时间戳<b class="blue">{{tsCount}}</b>个</h3>
                </div>
            </div>
        </van-dialog>
        <!-- 上传提示框，余额不足 -->
        <van-dialog 
            v-model="balanceNoEnoughDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            :confirmButtonText="userInfo.userType == 'ADMIN_ACCOUNT'?'立即充值':'我知道了'" 
            :show-cancel-button="userInfo.userType == 'ADMIN_ACCOUNT'"
            cancelButtonText="取消" 
            @confirm="goRecharge('up')"
            @cancel="clearInput"
        >
            <div class="dialog_cnt">
                <div class="content">
                    <h3 class="alignCenter" v-if="userInfo.userType == 'ADMIN_ACCOUNT'">时间戳余额不足</h3>
                    <h3 class="alignCenter" v-else>时间戳余额不足，请联系主账号充值</h3>
                    <p>本文件大小为<b class="blue">{{fileSize}}</b>，存储需消耗可信时间戳<b class="blue">{{tsCount}}</b>个</p>
                </div>
            </div>
        </van-dialog>
        <!-- 身份子账号，主账号分配余额不足情况下上传 -->
        <van-dialog 
            v-model="balanceNoEnoughChildDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            confirmButtonText="我知道了" 
            :show-cancel-button="false"
            @confirm="balanceNoEnoughChildDiaBox=false"
        >
            <div class="dialog_cnt">
                <div class="content">
                    <h3>您的时间戳已用完，请联系主账号再次分配</h3>
                    <p>本文件大小为<b class="blue">{{fileSize}}</b>，存储需消耗可信时间戳<b class="blue">{{tsCount}}</b>个</p>
                </div>
            </div>
        </van-dialog>
        <!-- 充值后回来的弹框 -->
        <van-dialog 
            v-model="updateBalanceDiaBox" 
            title="提示" 
            class="mydialogBox" 
            confirmButtonColor="#008AFF" 
            :confirmButtonText="rechargeSceneBtnText" 
            show-cancel-button
            cancelButtonText="继续充值" 
            @confirm="upORdown"
            @cancel="goRecharge"
        >
            <div class="dialog_cnt">
                <div class="content">
                    <h3 class="alignCenter">我已充值成功</h3>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { findOpusInfo,complete,me,opusList,updateOpus,findBalance,deleteOpusSourceFile,lengthCount,supplementSts,payArrearageMoney,cancelStsUpload,getPermission} from '@/api/service'
import { formatDate,formatYMD,filterParams } from '@/utils/filter'
import { encrypt } from '@/utils/aes.js'
import { ossMultipartUpload,ossAbortMultipartUpload} from '@/utils/ossMultipartUpload'
import CryptoJS from 'crypto-js'
import { arrayBufferToWordArray } from '@/utils/buffer'
import { mapState } from "vuex";
var pos = 0
var end
var chunkSize = 204800 //409600;//204800;
var lastprogress = 0
var sha256 = CryptoJS.algo.SHA256.create()
var sha1 = CryptoJS.algo.SHA1.create()
var interval = null;
export default {
    data() {
        return {
            serialNo: '',
            opusInfo: {},
            fil: {},
            fileHash: '',
            fileHashSha1:'',
            zhe: false,
            currentRate:0,
            percentage: 0,
            diaProgress: false,
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                // type: 'video/x-flv',
                // type: "rtmp/mp4",
                // type: "application/x-mpegURL",
                // type: "video/mp4",
                ],
                poster: "", // 封面地址
                notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                timeDivider: true, // 当前时间和持续时间的分隔符
                durationDisplay: true, // 显示持续时间
                remainingTimeDisplay: false, // 是否显示剩余时间功能
                fullscreenToggle: true // 是否显示全屏按钮
                }
            },
            serialNos:[],
            searchParam:{page:1,size:10},
            last:false,
            index:0,
            videoMask:false,

            downEnoughDiaBox:false,
            downNoEnoughDiaBox:false,
            downNoEnoughChildDiaBox:false,
            deleteDiaBox:false,
            balanceNoEnoughDiaBox:false,
            balanceNoEnoughChildDiaBox:false,
            balanceEnoughDiaBox:false,
            updateBalanceDiaBox:false,
            tsCount:0,//扣戳个数
            rechargeScene:'',
            rechargeSceneBtnText:'继续下载',
            detectionStop:false,//是否停止上传
            storeId:'',//上传和取消接口用到
        };
    },

    components: {},

    filters: {
        formatDate: formatDate,
        formatYMD:formatYMD,
    },

    computed: {
        applyIdType() {
            switch (this.opusInfo.applyIdType) {
                case 101:
                    return '身份证'
                    break
                case 102:
                    return '军官证'
                    break
                case 103:
                    return '护照'
                    break
                case 104:
                    return '士兵证'
                    break
                case 110:
                    return '营业执照'
                    break
                case 111:
                    return '企业组织结构代码证'
                    break
                case 112:
                    return '统一社会信用代码证'
                    break
                case 109:
                    return '台胞证'
                    break
                case 113:
                    return '港澳通行证'
                    break
            }
        },
        suffix() {
            if (this.opusInfo.sourceFileStorePath) {
                let path = this.opusInfo.sourceFileStorePath
                let index = path.lastIndexOf('.')
                let extension = path.substring(index + 1, path.length)
                let arry_format = ['png', 'gif', 'jpg', 'jpeg']
                if (arry_format.indexOf(extension) == '-1') {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        isVideo(){
            if (this.opusInfo.sourceFileStorePath) {
                let path = this.opusInfo.sourceFileStorePath
                let index = path.lastIndexOf('.')
                let extension = path.substring(index + 1, path.length)
                let arry_format = ['mp4','3gp','ogg','webm']
                if (arry_format.indexOf(extension) == '-1') {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        fileSize(){
            let size=this.fil[0] ? Math.floor(this.fil[0].size) : 0;
            
            let num = 1024.00; //byte
            if (!size)
                return "";
            if (size < num)
                return size + "B";
            if (size < Math.pow(num, 2))
                return (size / num).toFixed(2) + "K"; //kb
            if (size < Math.pow(num, 3))
                return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
            if (size < Math.pow(num, 4))
                return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
            return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
        },
        access_token(){
            return this.$store.state.userInfo.me.accessToken
        },
        ...mapState({
            userInfo: (state) => state.userInfo.userInfo,
            meInfo: (state) => state.userInfo.me,
        }),
    },

    watch: {
        //监听相同路由下参数变化的时候，从而实现异步刷新
        '$route'(to,from) {
            //做一些路由变化的响应
            //重新获取数据
            this.initData();
        },
        // balanceNoEnoughDiaBox(newVal){
        //     if(!newVal){
        //         this.$refs.inputer1.value=null;
        //         this.$refs.inputer2.value=null;
        //     }
        // },
        balanceNoEnoughChildDiaBox(newVal){
            if(!newVal){
                this.$refs.inputer1.value=null;
                this.$refs.inputer2.value=null;
            }
        },
    },

    async created() {
        this.initData()
    },

    mounted() {},

    destroyed(){
        clearInterval(interval);
    },

    methods: {
        clearInput(){
            this.$refs.inputer1.value=null;
            this.$refs.inputer2.value=null;
        },
        async initData(){
            this.serialNo = this.$route.query.serialNo
            await this.getInfo(this.serialNo)
            let {serialNos,searchParam}=this.$getlocalStorage('listObj');
            this.serialNos=serialNos;
            if(!searchParam){
                this.searchParam={page:1,size:10};
                //从申请成功页面过来的需要判断数据有多少，应该到第几页。向下取整，然后去重。
                this.searchParam.page=Math.floor(serialNos.length/this.searchParam.size)<1?1:Math.floor(serialNos.length/this.searchParam.size)
            }else{
                this.searchParam=searchParam;
            }
            this.index=this.serialNos.indexOf(this.serialNo);
            console.log(this.index)
            if(this.isVideo){
                let path = this.opusInfo.sourceFileStorePath
                let index = path.lastIndexOf('.')
                let extension = path.substring(index + 1, path.length)
                this.playerOptions.sources.push({
                    src: this.opusInfo.sourceFileStorePathUrl,
                    type: `video/${extension}`
                });
            }
        },
        imgPreview(path){
            ImagePreview([path]);
        },
        async getInfo(data) {
            let res = await findOpusInfo(data)
            this.opusInfo = res
        },
        copy() {
            var clipboard = new this.Clipboard('.copybtn')
            var that = this
            clipboard.on('success', (e) => {
                // console.log('复制成功')
                // 释放内存
                that.$toast.success('复制成功')
                clipboard.destroy()
            })
            clipboard.on('error', (e) => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')
                that.$toast('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        //1.选择文件，计算hash
        addfile(n) {
            clearInterval(interval);
            let inputDOM;
            if(n==1){
                inputDOM = this.$refs.inputer1
            }else{
                inputDOM = this.$refs.inputer2
            }
            this.fil = inputDOM.files
            let size = Math.floor(this.fil[0].size)
            this.percentage=0;
            this.zhe = true
            pos = 0
            chunkSize = 204800 //409600;//204800;
            lastprogress = 0
            sha256 = CryptoJS.algo.SHA256.create()
            sha1 = CryptoJS.algo.SHA1.create()
            interval = setInterval(function () {
                me().then((res) => {
                    console.log('正在保活')
                }).catch((err) => {
                    console.log(err)
                });
            }, 60000);
            this.progressiveRead(inputDOM.files[0])
        },
        progressiveRead(file) {
            // 20KiB at a time
            pos = 0
            chunkSize = 204800 //409600;//204800;
            lastprogress = 0
            let reader = new FileReader()
            setTimeout(this.progressiveReadNext(file, reader), 0)
        },
        progressiveReadNext(file, reader) {
            var that = this
            end = Math.min(pos + chunkSize, file.size)
            if (file.slice) {
                var blob = file.slice(pos, end)
            } else if (file.webkitSlice) {
                var blob = file.webkitSlice(pos, end)
            }
            reader.readAsArrayBuffer(blob)
            reader.onload = (e) =>{
                pos = end
                var wordArray = arrayBufferToWordArray(e.target.result)
                sha256.update(wordArray)
                sha1.update(wordArray)
                var progress = Math.floor((pos / file.size) * 100)
                if (progress > lastprogress) {
                    that.percentage = progress
                    lastprogress = progress
                }
                if (pos < file.size) {
                    setTimeout(that.progressiveReadNext(file, reader), 0)
                } else {
                    that.fileHashSha1=sha1.finalize().toString().toUpperCase();
                    that.fileHash = sha256.finalize().toString().toUpperCase();
                    setTimeout(function() {
                        that.zhe = false
                        that.percentage = 0
                        that.UploadFile()
                    }, 1000)
                }
            }
        },
        //2.比对hash，判断余额等是否符合上传条件。给出对应提示操作弹框。
        async UploadFile() {
            let that = this;
            if(that.fileHash!==that.opusInfo.fileHash){
                that.$toast('当前上传的文件与原件不一致，请重新上传')
                that.$refs.inputer1.value=null;
                that.$refs.inputer2.value=null;
                return false;
            }
            this.updateBalanceDiaBox=false;
            let serialNo=that.opusInfo.pdfSerialNo;
            let fileSize=Math.floor(that.fil[0].size);
            try {
                //获取扣戳个数接口
                let {resultList}=await lengthCount([{
                    keyType:1,
                    fileSize,
                    key:serialNo,
                }])
                this.tsCount=resultList[0].storeCount;
                let {deductible,errorMessage} = await findBalance(this.tsCount);
                if(deductible==1){ //余额够扣给出提示继续上传
                    if(resultList[0].isFirstUpload && ((fileSize / Math.pow(1024.00, 2)).toFixed(2)<=200)){
                        this.handleUpload();
                    }else{
                        this.balanceEnoughDiaBox=true;
                    }
                }else if(deductible == 4){ //身份主账号，余额不足
                    this.balanceNoEnoughDiaBox=true;
                }else if(deductible == 2){ //身份子账号，主账号余额不足
                    if(resultList[0].isFirstUpload && ((fileSize / Math.pow(1024.00, 2)).toFixed(2)<=200)){
                        this.handleUpload();
                    }else{
                        this.balanceNoEnoughDiaBox=true;
                    }
                }else if(deductible == 3){ //3 身份子账号，主账号分配次数达上限
                    if(resultList[0].isFirstUpload && ((fileSize / Math.pow(1024.00, 2)).toFixed(2)<=200)){
                        this.handleUpload();
                    }else{
                        this.balanceNoEnoughChildDiaBox=true;
                    }
                }else{
                    this.$toast(errorMessage)
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                }
            } catch (error) {
                console.log(error)
            }
        },
        //3.开始上传，并轮询查询状态。
        async handleUpload(){
            this.balanceEnoughDiaBox=false;
            this.updateBalanceDiaBox=false;
            let serialNo=this.opusInfo.pdfSerialNo;
            let fileSize=Math.floor(this.fil[0].size);
            try {
                let res=await supplementSts(encrypt({
                    serialNo,
                    fileSize,
                    fileHash256: this.fileHash,
                    fileHashSha1: this.fileHashSha1,
                    partnerType:this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0
                }))
                this.storeId=res.storeId;
                var { accessKey, secretKey, secretToken, bucket, key }=res.stsInfoDTO;
                this.diaProgress = true;
                this.detectionStop=false;
            } catch (error) {
                console.log(error);
                if(error.data.code == 4){
                    this.balanceNoEnoughDiaBox=true;
                }else if(error.data.code == 2){
                    this.balanceNoEnoughDiaBox=true;
                }else if(error.data.code == 3){
                    this.balanceNoEnoughChildDiaBox=true;
                }else{
                    this.$toast(error.data.message)
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                }
                return false
            }
            try {
                await ossMultipartUpload({
                    fileHash:this.fileHash,
                    accessKey,
                    secretKey,
                    secretToken,
                    bucket,
                    key,
                    file:this.fil[0],
                    storeId:this.storeId,
                }, ({ percentage }) => {
                    this.percentage = percentage;
                })
                this.detection();
            } catch (error) {
                console.log(error)
            }
            
        },
        async detection() {
            let that = this;
            if(this.detectionStop) return;
            try {
                let res = await complete({
                    serialNo: that.opusInfo.pdfSerialNo,
                    storeId:this.storeId,
                });
                console.log(res);
                if (res.sourceFileUploadType == 0) {
                    setTimeout(() => {
                        that.detection();
                    }, 1000);
                } else {
                    that.$toast.success("上传成功");
                    that.diaProgress = false;
                    that.initData();
                    updateBalance();
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                }
            } catch (err) {
                if (err.data.code == -1) {
                    this.$toast(err.data.message);
                    this.diaProgress = false;
                    this.detectionStop=true;
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                } else {
                    this.$toast(err.data.message);
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                    return false;
                }
            }
        },
        //4.上传过程中可以手动关闭结束上传。
        async close(){
            try {
                if (this.percentage === 100) {
                    this.$toast('当前文件即将上传成功，请稍后处理');
                } else {
                    clearInterval(interval) // 清空保活接口
                    interval = null
                    this.detectionStop=true;//轮询停止
                    await ossAbortMultipartUpload() // 取消oss请求
                    // 需要调用终止分片的接口 （已经上传到服务器的就不能被取消了）
                    await cancelStsUpload({
                        serialNo: this.opusInfo.pdfSerialNo,
                        storeId:this.storeId,
                    })
                    this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                    this.diaProgress=false;
                    this.percentage=0;
                } 
            } catch (error) {
                console.log(error);
                this.$toast(error.data.message);
                this.diaProgress = false;
            }
        },
        async overUpload(action, done){
            if (action !== 'confirm' && action !== 'cancel') {
                try {
                    if (this.percentage === 100) {
                        this.$toast('当前文件即将上传成功，请稍后处理');
                    } else {
                        clearInterval(interval) // 清空保活接口
                        interval = null
                        this.detectionStop=true;//轮询停止
                        await ossAbortMultipartUpload() // 取消oss请求
                        // 需要调用终止分片的接口 （已经上传到服务器的就不能被取消了）
                        await cancelStsUpload({
                            serialNo: this.opusInfo.pdfSerialNo,
                            storeId:this.storeId,
                        })
                        this.$store.commit('axiosCancel/clearAxiosPromiseCancelArr')
                        this.$refs.inputer1.value = null;
                        this.$refs.inputer2.value = null;
                        done();
                    } 
                } catch (error) {
                    if(error.data.code==-1){
                        this.percentage=100;
                        this.detection();
                        return true;
                    }
                    this.diaProgress = false;
                    this.$refs.inputer1.value = null;
                    this.$refs.inputer2.value = null;
                    this.$toast(error.data.message);
                    console.log(error);
                }
            }else{
                done();
            }
        },
        playVideo(){
            this.videoMask=true;
        },
        upORdown(){
            if(this.rechargeScene=='up'){
                this.UploadFile('goOn')
            }
            if(this.rechargeScene=='down'){
                this.download('goOn')
            }
        },
        async download(str) {
            let that = this;
            this.updateBalanceDiaBox=false;
            if (str == "tsa") {
                that.downTSA(this.opusInfo.pdfSerialNo);
            } else {
                if(str == "goOn"){
                    let res = await findOpusInfo(this.serialNo);
                    this.opusInfo = res;
                }
                if(this.opusInfo.isExpired){//已过期
                    let {deductible} = await findBalance(this.opusInfo.storeTsCount);
                    if(deductible==1){ //余额够扣给出提示继续下载
                        if(str == "goOn"){
                            await this.handlDownload();
                        }else{
                            this.downEnoughDiaBox=true; 
                        }
                    }else if(deductible == 4){//身份主账号，余额不足
                        this.downNoEnoughDiaBox=true;
                    }else if(deductible==2){//身份子账号，主账号余额不足
                        this.downNoEnoughDiaBox=true;
                    }else{//3 身份子账号，主账号分配次数达上限
                        this.downNoEnoughChildDiaBox=true;
                        // that.$message.error('该文件尚有未支付的存储费，您的时间戳已用完，请联系主账号再次分配')
                    }
                }else{//下载
                    this.downFile()
                }
            }
        },
        //下载证书
        async downTSA(serialNo) {
            let baseURL;
            if (process.env.NODE_ENV === "development") {
                baseURL = "/api/api";
            } else {
                baseURL = "/opus/api";
            }
            //window.open(baseURL + `/opus/download/file/${serialNo}`)
            let link = document.createElement("a");
            link.style.display = "none";
            link.target = "_blank";
            link.href = baseURL + `/opus/download/file/${serialNo}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        //下载原件
        downFile(){
            let link = document.createElement("a");
            link.style.display = "none";
            link.target = "_blank";
            link.href = this.opusInfo.sourceFileStorePathUrl;
            link.download = this.opusInfo.opusName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async handlDownload(){
            try {
                // 先调扣费接口
                await payArrearageMoney({
                    serialNo:this.opusInfo.pdfSerialNo,
                    partnerType:this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0
                })
                let res = await findOpusInfo(this.serialNo);
                this.opusInfo = res;
                this.downFile();
                this.downEnoughDiaBox=false;
                this.updateBalance()
                this.initData();
            } catch (error) {
                if(error.data.code == 4){
                    this.downNoEnoughDiaBox=true;
                }else if(error.data.code == 2){
                    this.downNoEnoughDiaBox=true;
                }else{
                    this.downNoEnoughChildDiaBox=true;
                }
                return false
            }
        },
        cancelUpload(){
            this.balanceEnoughDiaBox=false;
            this.$refs.inputer1.value = null;
            this.$refs.inputer2.value = null;
        },
        async deleteFile(){
            if (this.meInfo.parentId !== "0") {
                let {permissionValue}=await getPermission({type:1});
                if(permissionValue===1){//不可以删除
                    this.$toast('暂无权限删除，请联系主账号处理')
                    return
                }
            }
            this.deleteDiaBox=true;
        },
        handleDelete(){
            deleteOpusSourceFile({serialNo:this.serialNo}).then((res)=>{
                // this.deleteDiaBox=false;
                this.$toast("删除成功！");
                this.initData();
            }).catch((err)=>{
                this.$toast("删除失败！");
            })
        },
        // 更新备注
        async updateRemarkShow() {
            this.$set(this.opusInfo, "modified", true);
            this.$forceUpdate();
        },
        async updateRemark() {
            const { serialNo } = this.$route.query;
            const { applyRemark } = this.opusInfo;
            let res = await updateOpus({ serialNo, applyRemark });
            if (res.code === 200) {
                this.$toast.success("更新成功！");
                this.$set(this.opusInfo, "modified", false);
                this.$forceUpdate();
            }
        },
        goRecharge(rechargeScene){
            if(this.userInfo.userType !== 'ADMIN_ACCOUNT'){
                this.downNoEnoughDiaBox=false;
                this.balanceNoEnoughDiaBox=false;
                this.$refs.inputer1.value=null;
                this.$refs.inputer2.value=null;
                return true;
            }
            if(rechargeScene==='down'){
                this.rechargeScene=rechargeScene;
                this.rechargeSceneBtnText='继续下载'
            }
            if(rechargeScene==='up'){
                this.rechargeScene=rechargeScene;
                this.rechargeSceneBtnText='继续上传'
            }
            this.downNoEnoughDiaBox=false;
            this.balanceNoEnoughDiaBox=false;
            this.$router.push({
                path:'/mine/Account',
                query:{
                    url:process.env.VUE_APP_ACCOUNTUI+`/userAccount/buy?sourceType=952310&clientId=952310&partnerType=${this.$getlocalStorage('partnerType')? this.$getlocalStorage('partnerType'):0}`
                }
            })
            if(rechargeScene){
                this.updateBalanceDiaBox=true;
            }
        },
        async updateBalance(){
            try {
                let balance = await findBalance(0)
                this.$store.commit('balance/setBalance', balance)
            } catch (error) {
                this.$toast('查询余额异常')
            }
        },
        pre(){
            this.serialNo=this.serialNos[this.index-1];
            this.last=false;
            this.percentage=0;
            this.$router.push({path: '/file/FileDetail',query:{serialNo:this.serialNo}})
        },
        async next(){
            let that=this;
            this.percentage=0;
            if((this.index+1)==this.serialNos.length){
                this.searchParam.page++;
                let res = await opusList(filterParams(this.searchParam))
                if(res.data.length==0){
                    this.last=true;
                }else{
                    let serialNos=[];
                    res.data.forEach((objItem,key)=>{
                        serialNos.push(objItem.serialNo)
                        if(key==(res.data.length-1)){
                            //数组去重
                            this.serialNos=[...new Set([...this.serialNos,...serialNos])]
                            that.$setlocalStorage("listObj",{
                                searchParam:that.searchParam,
                                serialNos:this.serialNos
                            });
                            this.serialNo=this.serialNos[this.index+1]
                            that.$router.push({path: '/file/FileDetail',query:{serialNo:this.serialNo}})
                        }
                    });
                }
            }else{
                this.serialNo=this.serialNos[this.index+1]
                this.$router.push({path: '/file/FileDetail',query:{serialNo:this.serialNo}})
            }
        }
    },
};
</script>
<style src="../../assets/css/fileDetail.less" scoped lang="less"></style>
